/* eslint-disable no-unused-vars */
import React from 'react-router-dom';
import { selectPageIsLoading } from 'store/page/pageSlice';
import { useAppSelector } from 'store/hooks';
import { MIN_TABLET_WIDTH } from 'utils/utils';
import MobileHeader from 'components/mobileHeader/mobileHeader';
import DesktopHeader from 'components/desktopHeader/desktopHeader';
import { useViewport } from 'contexts/viewportContext';

export default function Header() {
  const pageIsLoading = useAppSelector(selectPageIsLoading);
  const { width } = useViewport();
  //   const isMobileAdaptiveModeOn = window.innerWidth < MIN_TABLET_WIDTH;
  const isMobileAdaptiveModeOn = width <= MIN_TABLET_WIDTH;

  return isMobileAdaptiveModeOn ? (
    <MobileHeader pageIsLoading={pageIsLoading} />
  ) : (
    <DesktopHeader pageIsLoading={pageIsLoading} />
  );
}
